export default {
      id: "canli_zirve_badge-usage",
      viewBox: "0 0 169 18",
      url: "/" + "images/icons.3.109.2.svg#canli_zirve_badge-usage",
      toString: function () {
        return this.url;
      }
    }